// Remove Gift Tier Item from all carts
async function removeGiftTier(variantId) {
  // Cart data collection
  const cartData = await getCartData();
  const cartItems = cartData.items;
	const giftItem = cartItems.find((item) => item.variant_id == variantId && item.properties && item.properties._promo);
  // If gift item is in cart, then remove it.
  if (giftItem) {
    await removeItem(giftItem.key);
    await renderCartDrawer();
  }
}

// Get Cart Data
async function getCartData() {
  const response = await fetch('/cart.js');
  const data = await response.json();
  return data;
}

// Remove product from cart by line item key
async function removeItem(lineItemKey) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: 0,
    }),
  });
  const data = await response.json();
  return data;
}

// Section API Reload Cart-Drawer
async function renderCartDrawer() {
	// Update Cart Drawer
	fetch(window.Shopify.routes.root + "?sections=cart-drawer")
		.then((res) => res.json()) // Parse the response as JSON
		.then((data) => {
			const cartDrawer = document.querySelector("cart-drawer");
			// Convert the HTML string into a document object that can be parsed to replace the cart drawer
			const parser = new DOMParser();
			const doc = parser.parseFromString(data["cart-drawer"], "text/html");
			// Get the new cart drawer and replace the existing one, and check if is empty to add class
			cartDrawer.querySelector(".drawer__inner").replaceWith(doc.querySelector(".drawer__inner"));
			if (doc.querySelector("cart-drawer").classList.contains("is-empty")) {
				// console.log("Cart Drawer is empty");
				cartDrawer.classList.add("is-empty");
			} else {
				cartDrawer.classList.remove("is-empty");
			}
		})
		.catch((error) => {
			console.error("Error reloading cart drawer: ", error);
		});
	// Update Cart Icon Bubble
	fetch(window.Shopify.routes.root + "?sections=cart-icon-bubble")
		.then((res) => res.json()) // Parse the response as JSON
		.then((data) => {
			const cartIconBubble = document.querySelector("#cart-icon-bubble");
			// Convert the HTML string into a document object that can be parsed to replace the cart drawer
			const parser = new DOMParser();
			const doc = parser.parseFromString(data["cart-icon-bubble"], "text/html");
			// Get the new cart drawer and replace the existing one, and check if is empty to add class
			cartIconBubble.innerHTML = doc.querySelector(".shopify-section").innerHTML;
		})
		.catch((error) => {
			console.error("Error reloading cart bubble count: ", error);
		});
}

// removeGiftTier('43318887481396'); // Mini Neck Cream
// removeGiftTier('41375242027060'); // Sunscreen
// removeGiftTier('42426506706996'); // Mini Dewy